import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './SearchCancel.module.scss';
import { TSearchCancel } from './definitions';
import { Row, Col } from 'antd';
import Text from 'Pages/Home/Components/Atoms/Text';

export default function SearchCancel({ onClick }: TSearchCancel) {
  return (
    <Col>
      <Row
        className={Styles['search-cancel']}
        align="middle"
        justify="space-between"
        onClick={onClick}
      >
        <div className={Styles['search-cancel__divider']} />
        <Text className={Styles['search-cancel__text']}>Cancel</Text>
      </Row>
    </Col>
  );
}
